import React from "react";
import { useSelector } from "react-redux";
import GrammarViewer from "../../../../../../../common/grammarViewer/GrammarViewer";

const Grammar = ({answer = null}) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  return (
    <div className="viewopen-detail on">
      <div className="viewopen-detail-inner">
        <div className="pvBox">
          <div className="pv-inner">
            <div className="pv-cont">
              <GrammarViewer>{answer ? answer : answeringQuestions.data.exmpCn }</GrammarViewer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default Grammar;
